__webpack_require__.p = "/dark-mode-reports/referrals-hub/";